import React, { useState, useEffect } from "react";
import { HTTP } from "../api/http-common";
import { useGlobalContext } from "./GlobalContext";
import AdminProfile from "./../pages/Admin/AdminProfile"
import VendorProfile from "./../pages/Vendor/VendorProfile"
import MemberProfile from "./../pages/Member/MemberProfile"

function Profile() {
  const { globalUserVar, isAuthenticated, setIsAuthenticated } = useGlobalContext();
  const [role, setRole] = useState(3);
  useEffect(() => {
    // console.log('here');
    let userObj = localStorage.getItem('userObj');
    if (userObj != null && userObj !== "") {
      let userJson = JSON.parse(userObj);
      setRole(userJson.role.id)
    }
  }, []);
  const renderComponent = () => {
    return (
      <div className="mt-8">
        <>
          {role == "1" ? (
            <AdminProfile />
          ) : role == "2" ? (
            <VendorProfile />
          ) : (
            <MemberProfile />
          )}
        </>
      </div>
    );
  };
  return (
    <>
      {renderComponent()}
    </>
  )
}

export default Profile